const en = {
  home: 'Home',
  dashboard: 'Dashboard',
  noServicesFoundPleaseTryAgain: 'No Services Found',
  serviceUsage: 'Service usage',
  more: 'More',
  close: 'Close',
  verificationServices: {
    title: 'Verification services',
    description: 'This service enables users to verify documents issued by the MOJ electronically',
    userNeed: 'I want to verify',
    browseVerificationServices: 'Browse verification services',
  },

  electronicServices: {
    title: 'E-Services',
    mostUsed: 'Most Used',
    judiciary: 'The Judiciary',
    realEstate: 'Real Estate',
    documentation: 'Notarization',
    lawyers: 'Lawyers',
  },

  search: 'Search',
  back: 'Back',
  endDate: 'Expiry Date',
  currentServices: 'Current Services',
  searchResult: 'Search Results',
  realEstates: 'Real Estates',
  marrigeContracts: 'Marrige Contracts',
  judicialLicences: 'Judicial Licences',
  searchLengthError: 'Search message less than four parts',
  all: 'All',
  faq: 'FAQs',
  loading: 'Loading Data...',
  useTheService: 'Service usage',
  startTheService: 'Start the Service',
  portalServices: {
    title: 'E-Services',
    allServices: 'All Services',
    searchInServices: 'Search services',
    readMore: 'Service Overview',
    use: 'Start the service',
    new: 'New',
    newlyAdded: 'New',
    modified: 'Modified',
    favorites: 'Favorites',
    mostUsed: 'Most Used',
    useTheService: 'Service usage',
    moveToService: 'Go to Service',
  },
  serviceDetails: {
    describeService: 'Service description',
    steps: 'Steps to apply for the service',
    serviceRequirements: 'Service Requirements',
    channels: 'Service channels',
    serviceInformation: 'Please note',
  },
  services: {
    searchHere: 'Search for a service',
  },
  router: {
    licenseGuide: 'Licensed Professionals Directory',
    notifications: 'Notifications',
    verificationServices: 'Verification Services',
    privacyPolicy: 'Privacy Policy',
    termsAndConditions: 'Terms and Conditions',
    home: 'Home',
    mostUsedServices: 'E-Services',
    theSearch: 'The search',
    contactUs: 'Contact Us',
  },
  serverErrors: {
    NOT_FOUND: 'We cannot serve you at the moment. Please try again later',
    SERVER_ERROR: 'Something went wrong, please try again later',
  },
  telemetry: {
    quickAccessLink: 'clicking on quick navigation link for',
    moreDetails: 'clicking on the more link for',
    serviceLink: 'clicking on the link for:',
    forCard: 'for card',
    dashboarLink: 'reaching the HelpConnect',
  },
  fetchingData: 'Loading Data ...',
  viewSearchResults: 'Showing {count} Search Results',
  browseService: 'Browse service',
  noSearchResultsFound: 'No results matching the entered data',
  pleaseRevalidateSearchCriteriaAndCheckAgain: 'Please verify the data and try again.',
  mostProminentServices: 'Featured Services',
  showMore: 'Show more',
  showDetails: 'Show Details',
  latestNotifications: 'Latest Notifications',
  judicialProfile: 'Judicial Profile',
  judicialProfileDescription: 'All your judicial information; the Judiciary, POAs, and other services.',
  judicialProfileFirstDescription: 'All your judicial information',
  judicialProfileSecondDescription: 'Judiciary, POAs, and other services.',
  viewAll: 'View All',
  viewLess: 'View Less',
  serviceExecutionTime: 'Service Processing Time',
  serviceExecutionTimeDescription: 'from {from} to {to}',
  beneficiaries: 'Beneficiaries',
  serviceFees: 'Service fees',
  commonFaqs: 'FAQs',
  checkFaqs: 'View FAQs',
  clickHere: 'Click here',
  allServices: 'All services',
  downloadApp: 'Download Najiz app',
  usageGuide: 'Usage guide',
  downloadUsageGuide: 'Download usage guide',
  theDescription: 'Description',
  theRequirments: 'Requirements',
  theSteps: 'Steps',
  serviceDescription: 'Service description',
  serviceRequirments: 'Service requirements',
  stepsToApplyForTheService: 'Steps to apply for the service',
  submitNewRequest: 'Submit new request',
  followUpOnPreviousRequest: 'Track Previous Request',
  authenticationOfCompletedRequest: 'Authentication of Completed Request',
  serviceVideoExplaination: 'Service video explaination',
  youShouldKnow: 'Please note',
  share: 'share',
  copyServiceLink: 'Copy service link',
  serviceLinkCopiedSuccessfully: 'Service link copied successfully',
  attorneyUpdatedSuccessfully: 'POA data updated successfully',
  instant: 'Instant',
  sections: 'Sections',
  searchResults: 'Search results ({searchText})',
  searchResultFor: 'Search result for',
  resultFound: 'result found',
  sessionFollowUp: 'Session follow up',
  accountUdpdatedSuccesfully: 'Account data updated successfully',
  accountsManagements: 'Accounts managements',
  email: 'Email',
  withMaxLengthChars: 'Maximum {length} characters',
  serviceProviderChannels: 'Service provider channels',

  contactWithUs: {
    title: 'Contact Us',
    slogan: 'We are constantly working to make your experience with judicial services easier. Find the support channel that best suits your needs.',
    contactInsideKSA: 'Contact Us from Within the Kingdom',
    fromSunToThurs: 'Sunday to Thursday',
    fromInsideKSA: 'From Within the Kingdom of Saudi Arabia',
    contactUs: 'Contact Us',
    contactOutsideKSA: 'Call Us from Outside the Kingdom',
    contactTime: 'From 10 AM to 3 PM (Sunday - Thursday)',
    fromOutsideKSA: 'From Outside the Kingdom of Saudi Arabia',
    messageUs: 'Message Us',
    allWeekDays: 'All Days of the Week',
    allTheTime: 'All Times',
    instantChat: 'Instant Chat',
    chatWithUs: 'Chat with Us',
    pleaseToServeYou: 'We\'re happy to At your service at all Najiz centers.',
    najizCenterRiyadhBranch: 'Najiz Center, Riyadh Branch',
    najizCenterRiyadhBranchLocation: 'Anas Ibn Malik Road, Al Malqa, Riyadh 13524',
    location: 'Location',
    workingDays: 'Working Days',
    workingTime: 'Working Times',
    from: 'From',
    until: 'Until',
    atMorning: 'Amongst',
    atNight: 'Evening',
    najizCenterJeddahBranch: 'Najiz Center, Jeddah Branch',
    najizCenterJeddahBranchLocation: 'Sari, Al Khalidiyah District, Jeddah 23423',
    najizCenterDammamBranch: 'Najiz Center, Dammam Branch',
    najizCenterDammamBranchLocation: 'Dhahran-Jubail Expressway, Al Rawdah, Dammam',
    socialMediaAccounts: 'Social Media Accounts',
    x: 'X',
    instagram: 'Instagram',
    snapchat: 'Snapchat',
    youtube: 'YouTube',
    facebook: 'Facebook',
    linkedin: 'LinkedIn',
    contactChannels: 'Channels for receiving inquiries and complaints',
    name: 'First Name',
    enterTheName: 'Enter the first name',
    email: 'Email',
    emailPlaceholder: 'Enter the email',
    phone: 'Mobile Number',
    phoneLabel: 'Phone',
    phonePlaceholder: '05xxxxx',
    messageTitle: 'Message Subject',
    messageTitlePlaceholder: 'Write your subject',
    messageCategory: 'Message Category',
    messageText: 'Message Text',
    theMessage: 'Write your message',
    send: 'Send',
    serviceAvailability: 'Service Availability',
    contactNumber: 'Contact Number',
    responseTime: 'Response Time',
    instant: 'Instant',
    serviceType: 'Service Type',
    liveChat: 'Live Chat',
    inquiriesAndComplaints: 'Inquiries and Complaints',
    supportWithSignLanguage: 'Sign Language Support',
    tenDaysWork: '10 Working Days',
    twoWorkDays: 'Two Working Days',
    judicialContact: 'Judicial Communication',
    signSupport: 'Sign Support',
    question: 'Question',
    suggestion: 'Suggestion',
    help: 'Help',
    messageSentSuccessfully: 'Message Sent Successfully',
    contactSample: 'Contact Sample',
  },

  validations: {
    fieldIsRequired: 'This field is required',
    onlyNumbers: 'Please enter only numbers',
    maxInputsLength: 'The maximum number of inputs is {length}',
    numbersExactLength: 'The number of numbers must be {length}',
    startsWith: 'Must start with {listText}',
    phoneNumber: 'The mobile number must begin with {key} and be {length} numbers',
    emailAddress: 'Please enter a valid email address',
    onlyArabicAndNumbers: 'Please enter only Arabic letters and numbers.',
    onlyArabicOrNumbers: 'Please enter only Arabic letters or numbers.',
    specialCharacters: 'Please do not enter special characters.',
    twitterId: 'The username must be http(s)://twitter.com/xyz123',
    facebookId: 'The username must be http(s)://facebook.com/xyz123',
    minWordsLength: 'The minimum number of words must be {length}',
    theNameMustBeBinary: 'The name must be binary',
    onlyArabic: 'You must enter only Arabic characters',
    duplicatePhoneNumberInContactInfo: 'The number of the first person must not match the number of the second person',
    duplicatePhoneNumberInApplicantInfo: 'The mobile number must not match the mobile number in your personal information.',
    alphaNumeric: 'Please enter only English letters and numbers.',
    alphaNumericAndSpecialChars: 'Please enter English letters, numbers, and special characters such as {chars}.',
  },

  faqs: {
    title: 'Faqs',
    description: 'Find answers to frequently asked questions about our products, services, and policies.',
    searchPlaceholder: 'Search (e.g: How to draft a statement of claim)',
    howCanWeHelpYou: 'How can we help you?',
    browseAllQuestions: 'Browse all questions',
    noQuestionsAvailable: 'No questions available.',
    shareQuestion: 'Share question',
    questionLinkCopiedSuccessfully: 'Question link copied successfully',
    questionDetails: 'Question details',
    questionDetailsNotAvailable: 'Question details are not available',
  },
  contactUs: {
    title: 'Contact us',
    forMoreContacts: 'More Contact Channels',
  },
  feedbackCard: {
    title: 'Comments and Suggestions',
    description: 'For any inquiries or feedback about government services, please fill in the required information.',
  },
  guideDialog: {
    title: 'Browse the service guide for booking mobile notary public appointments in an accessible format',
    browseGuideAccessible: 'Browse service guide in accessible format',
    tabs: {
      login: 'First: Login Process',
      steps: 'Second: Service Execution Steps',
      contact: 'Third: Contact Us',
    },
    login: {
      title: 'First: Login Process',
      mainPageAccess: 'Access the main page of Najiz platform',
      step1: 'From the main page, select (Individuals) to log in as a citizen, resident, or visitor.',
      step2: 'You will be redirected to the National Access login page, where you can log in by entering your ID/Iqama number directly and clicking on login.',
      step3: 'Confirm the displayed number by opening the Nafath app that was previously downloaded. After confirming the code, you will be redirected to the Najiz main page.',
      step4: 'Or by clicking the "Login" button using username and password, then you will be redirected to the National Single Sign-On page.',
      imageAlt: 'Login step',
    },
    steps: {
      title: 'Second: Service Execution Steps',
      intro: 'From the top bar, select (E-Services) to display all available services, then from the side menu select (Appointments Package), choose (Book Mobile Notary Public Appointment) service, and click (Use Service) button to view the service description and requirements, then click (Submit New Request) button',
      afterSubmit: 'After submitting a new request, fill in the service steps in the following order:',
      step1Title: 'Step One: Beneficiary Information',
      step1Item1: 'Select the applicant status: for myself or on behalf of the beneficiary.',
      step1Item2: 'When selecting "For myself": ID number and birth date information are retrieved automatically.',
      step1Item3: 'When selecting "On behalf of beneficiary": You must enter the ID number and birth date, then they will be verified.',
      step1Item4: 'After that, enter the mobile number and the type of beneficiary required to provide the service and proceed to the next step.',
      step2Title: 'Step Two: Service Details',
      step2Item1: 'Select the service type: either Power of Attorney issuance service or Real Estate Transfer service.',
      step2Item2: 'After selecting the service type, enter all information related to the selected service.',
      step2Item3: 'After completing the information, proceed to the next step.',
      step3Title: 'Step Three: Location Information',
      step3Item1: 'Allow the platform to access your location to accurately determine the location on the map.',
      step3Item2: 'After determining the location, proceed to the next step.',
      step4Title: 'Step Four: Available Appointments',
      step4Item1: 'Select the available appointment date and time according to your preference.',
      step4Item2: 'After selecting the date and time, you can proceed to preview the request before submission.',
      step5Title: 'Step Five: Request Preview',
      step5Item1: 'After completing all service steps, preview the request details to ensure all entered data is correct.',
      step5Item2: 'After confirmation, click on submit request.',
      step5Item3: 'A message appears confirming the success of the operation with the booked appointment information displayed.',
      imageAlt: 'Service step',
    },
    contact: {
      title: 'Third: Contact Us',
      subtitle: 'We are happy to provide support through communication channels',
      ticketService: 'Create a',
      ticketServiceBold: 'Judicial Communication Ticket',
      unifiedNumber: 'Unified Number',
      unifiedNumberValue: '1950',
      email: 'Contact Email',
      emailValue: '1950@moj.gov.sa',
    },
  },
};

export default en;
